"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Reference = /** @class */ (function () {
    function Reference(ref) {
        this.ref = {};
        Object.assign(this.ref, ref);
    }
    return Reference;
}());
exports.Reference = Reference;
//# sourceMappingURL=Reference.js.map